module.exports = __webpack_public_path__ + "img/42.5ad63c46.jpg";